import React, { ReactNode } from 'react';
import { Container } from './styles';

export type FooterLabelProps = {
  icon?: ReactNode;
  text: string;
  color: string;
};

export default function FooterLabel({ icon, text, color }: FooterLabelProps) {
  return (
    <Container>
      {icon && icon}
      <span style={{ color, marginLeft: icon ? 10 : 0 }}>{text}</span>
    </Container>
  );
}
